import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';

@Component({
  selector: 'app-cancelled-appointment',
  templateUrl: './cancelled-appointment.component.html',
  styleUrls: ['./cancelled-appointment.component.scss']
})
export class CancelledAppointmentComponent implements OnInit {

  cancelledAppointments:any
  show:boolean=false
  constructor(private spinner:NgxSpinnerService,private appointmentService:AppointmentService) { }
  ngOnInit(): void {
    this.show=false;
    this.spinner.show()
    let location=null;
    let diagId=null;
    let status="CANCEL"
    this.appointmentService.getAppointments(null,null,status,null,null,null).subscribe(res=>{
      this.cancelledAppointments=res.data
      this.show=true
      this.spinner.hide()

    })
  }

}
